<template>
  <BaseCard>
    <BaseCardBody clear-padding class="overflow-hidden relative">
      <img :src="adPost.display_url" class="aspect-[1/1] object-cover" />
      <a
        :href="adPost.permalink"
        target="_blank"
        class="absolute inset-0 w-full h-full flex items-center justify-center group hover:bg-black hover:bg-opacity-50 transition-all"
      >
        <span
          class="hidden group-hover:inline-flex text-white border border-white px-6 py-3 hover:bg-white hover:text-black transition-all rounded"
          >VIEW AD</span
        >
      </a>
    </BaseCardBody>
    <BaseCardBody class="space-y-5">
      <div class="text-gray-600 text-xs">{{ takenAt }}</div>
      <p v-if="hasCaptionText" class="break-words text-sm">
        {{ captionText }}
      </p>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
import moment from 'moment';
import { truncate } from 'lodash-es';

export default {
  props: {
    adPost: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasCaptionText() {
      return typeof this.adPost.caption_text === 'string';
    },
    captionText() {
      return this.hasCaptionText ? truncate(this.adPost.caption_text, { length: 125 }) : '';
    },
    takenAt() {
      return moment.utc(this.adPost.taken_at).local().format('DD/MM/YYYY HH:mm');
    },
  },
};
</script>
